<button pButton [icon]="icon" (click)="buttonClick($event)" pRipple type="button" [label]="label" class="p-button-outlined p-button-secondary"></button>